import { defineStore } from '/src/core/store';

export const useNetworkStore = defineStore('network', {
	state: () => ({
		// indeterminate until the first real getStatus() reading
		network: undefined,
	}),
	actions: {
		setNetwork (network) {
			this.network = network;
		},
	},
});
